import React, { useState } from "react"

interface UseExportMenuReturn {
  exportMenuAnchorEl: HTMLElement | null
  isExportMenuOpen: boolean
  handleExportClick: (event: React.MouseEvent<HTMLElement>) => void
  handleExportMenuClose: () => void
  handleGenerateNewFile: (callback: () => void) => void
  openExportMenu: (el: HTMLElement) => void
}

/**
 * Custom hook for managing export menu state and handlers
 */
export const useExportMenu = (
  isFetching: boolean,
  refreshTasks: () => void
): UseExportMenuReturn => {
  const [exportMenuAnchorEl, setExportMenuAnchorEl] =
    useState<null | HTMLElement>(null)

  const isExportMenuOpen = Boolean(exportMenuAnchorEl)

  const handleExportClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isFetching) return

    // Refresh tasks from sessionStorage before opening menu
    refreshTasks()

    setExportMenuAnchorEl(event.currentTarget)
  }

  const handleExportMenuClose = () => {
    setExportMenuAnchorEl(null)
  }

  const handleGenerateNewFile = (callback: () => void) => {
    handleExportMenuClose()
    callback()
  }

  const openExportMenu = (el: HTMLElement) => {
    if (isFetching) return
    refreshTasks()
    setExportMenuAnchorEl(el)
  }

  return {
    exportMenuAnchorEl,
    isExportMenuOpen,
    handleExportClick,
    handleExportMenuClose,
    handleGenerateNewFile,
    openExportMenu,
  }
}
